import { render, staticRenderFns } from "./mIndex.vue?vue&type=template&id=3b882b00&scoped=true"
import script from "./mIndex.vue?vue&type=script&lang=js"
export * from "./mIndex.vue?vue&type=script&lang=js"
import style0 from "./mIndex.vue?vue&type=style&index=0&id=3b882b00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_f33b182414a87044fb4ff91041025cb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b882b00",
  null
  
)

export default component.exports